import { render, staticRenderFns } from "./centerBottom.vue?vue&type=template&id=05324422&"
import script from "./centerBottom.vue?vue&type=script&lang=js&"
export * from "./centerBottom.vue?vue&type=script&lang=js&"
import style0 from "./centerBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports